import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

export const Container = styled.div`
  margin-top: ${(props) => (props.isReset ? '264px' : '178px')};
  position: absolute;
`;

export const PopupContainer = styled.div`
`;

export const PopupItem = styled.div`
  margin-top: 15px;
`;

export const Requirement = styled.span`
  padding-left: ${(props) => (props.checked ? '0' : '20px')};
`;

export const CheckedIcon = styled(Icon).attrs(() => ({
  name: 'check',
  color: 'green',
}))``;
